<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!displayConfirmMember) {
  <div class="row">
    <div class="col-3 mb-3">
      <mwp-member-search-form [isTestMemberSearch]="true" (emitSearchPayload)="search($event)" />
    </div>
    <div class="col-9">
      <mwp-member-members-grid [members]="members" (emitSelectedMember)="selectedMember($event)" header="Test Members" />
    </div>
  </div>
  }
  @if (displayConfirmMember) {
  <div>
    <mwp-member-confirm [member]="member" (emitBack)="back()" />
  </div>
  }
</div>